<template>
  <div class="card card-custom gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Configurações
        </span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          Manipule as configurações do sistema
        </span>
      </h3>
      <div class="card-toolbar"></div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-2 pb-0">
      <b-form style="margin-bottom: 20px">
        <div class="row">
          <div class="col-md-12">
            <b-form-group label="Permissões Paylogos:">
              <b-form-checkbox
                size="lg"
                v-model="configuracoesLocal.salvaEmitenteLocal"
                name="permissoes-salvaemitentelocal"
                :unchecked-value="false"
                :value="true"
              >
                Salvar emitente localmente quando for atualizado via Paylogos
                Portal
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>

        <b-button
          class="margin-btn-5"
          @click="salvar"
          variant="primary"
          :disabled="carregando"
        >
          <b-spinner
            v-if="carregando"
            small
            style="margin-bottom: 2px; margin-right: 3px"
          ></b-spinner>
          Salvar
        </b-button>
        <b-button
          class="margin-btn-5"
          @click="voltar"
          variant="danger"
          :disabled="carregando"
        >
          <b-spinner
            v-if="carregando"
            small
            style="margin-bottom: 2px; margin-right: 3px"
          ></b-spinner>
          Voltar
        </b-button>
      </b-form>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";

export default {
  name: "Configuracoes",
  data() {
    return {
      carregando: false,
      configuracoesLocal: {
        salvaEmitenteLocal: false
      }
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Configurações" }]);

    this.obterConfiguracoes();
  },
  computed: {
    ...mapGetters(["configuracoes"])
  },
  methods: {
    ...mapActions(["getConfiguracoes", "updateConfiguracoes"]),
    async buscarConfiguracoesPaylogos() {
      let vm = this;

      await this.getConfiguracoes();

      this.configuracoes.forEach(function(permissao) {
        let value = permissao.CONTEUDO == 1 ? true : false;

        switch (permissao.CAMPO) {
          case "SALVAR_EMITENTE_LOCALMENTE":
            vm.configuracoesLocal.salvaEmitenteLocal = value;
            break;
        }
      });

      vm.$nextTick(() => {
        vm.carregando = false;
      });
    },
    obterConfiguracoes() {
      let vm = this;

      this.carregando = true;

      if (this.verificado) {
        this.buscarConfiguracoesPaylogos();
      } else {
        window.addEventListener(
          "autorizado",
          function() {
            vm.buscarConfiguracoesPaylogos();
          },
          false
        );
      }
    },
    voltar() {
      this.$router.push("/dashboard");
    },
    async salvar() {
      this.carregando = true;

      await this.updateConfiguracoes({
        SALVAR_EMITENTE_LOCALMENTE: this.configuracoesLocal.salvaEmitenteLocal
          ? 1
          : 0
      });

      this.carregando = false;

      await Swal.fire({
        title: "",
        text: "Configurações salvas com sucesso.",
        icon: "success",
        confirmButtonClass: "btn btn-secondary"
      });
    }
  }
};
</script>

<style scoped>
.margin-btn-5 {
  margin-right: 5px;
}

.swal2-popup .swal2-content {
  margin-bottom: 2rem;
}
</style>
